export enum PotShape {
    Round = "ROUND",
    Square = "SQUARE",
    Bed = "BED"
}